// The name a NEW plan or template form opens with: `Plan MM/DD/YYYY HH:MM:SS`.
//
// The generator and the recogniser live together so they cannot drift: Perci may replace a name
// that is still this untouched default (plan-chat/planName.ts), and that check is only correct
// while it matches exactly what the form put there.

export type DefaultNamePrefix = 'Plan' | 'Template';

export function createDefaultName(prefix: DefaultNamePrefix, date: Date = new Date()): string {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${prefix} ${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
}

const DEFAULT_NAME = /^(Plan|Template) \d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/;

/** True when `name` is still the form's generated default, i.e. nobody typed it. */
export function isDefaultName(name: string | undefined | null): boolean {
  return DEFAULT_NAME.test((name ?? '').trim());
}
